module.exports = __webpack_public_path__ + "img/gift-09-c2.7e3e0561.png";